/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiCursorAIcon16Light } from './UiCursorAIcon16Light';
import { UiCursorAIcon16Regular } from './UiCursorAIcon16Regular';
import { UiCursorAIcon16Solid } from './UiCursorAIcon16Solid';
import { UiCursorAIcon20Light } from './UiCursorAIcon20Light';
import { UiCursorAIcon20Regular } from './UiCursorAIcon20Regular';
import { UiCursorAIcon20Solid } from './UiCursorAIcon20Solid';
import { UiCursorAIcon24Regular } from './UiCursorAIcon24Regular';
import { UiCursorAIcon24Solid } from './UiCursorAIcon24Solid';
import { UiCursorAIcon32Regular } from './UiCursorAIcon32Regular';
import { UiCursorAIcon64Regular } from './UiCursorAIcon64Regular';
var sizes = {
    16: {
        light: UiCursorAIcon16Light,
        regular: UiCursorAIcon16Regular,
        solid: UiCursorAIcon16Solid,
    },
    20: {
        light: UiCursorAIcon20Light,
        regular: UiCursorAIcon20Regular,
        solid: UiCursorAIcon20Solid,
    },
    24: {
        regular: UiCursorAIcon24Regular,
        solid: UiCursorAIcon24Solid,
    },
    32: {
        regular: UiCursorAIcon32Regular,
    },
    64: {
        regular: UiCursorAIcon64Regular,
    },
};
export var UiCursorAIcon = forwardRef('UiCursorAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
